module.exports = {
	payment_methods: [
		{ id: "new_visa_master" },
		{ id: "new_union_pay" },
		{ id: "visa_master" },
		{ id: "union_pay" },
		{ id: "alipay" },
		{ id: "wechat_pay" },
		{ id: "fps" }
	]
};
